var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orders"},[_c('Spinner',{attrs:{"is-loading":!_vm.orderPoints}}),_c('SubHeaderBlock'),_c('FilterBlock'),_c('div',{staticClass:"container"},[_c('TableBlock',{staticClass:"costs__table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }